import React from 'react';
import { Pencil, Zap, ClipboardList, MapPin } from 'lucide-react';
const tomos = [{
  n: 1,
  title: 'Niños Inicial — Ambientación al Agua',
  desc: 'El primer contacto con la pileta. Sumersión, flotación y confianza desde cero.'
}, {
  n: 2,
  title: 'Niños Inicial — Desplazamiento y Primeras Brazadas',
  desc: 'Patada de crol, brazada básica y primer largo asistido.'
}, {
  n: 3,
  title: 'Niños Intermedio — Estilos y Técnica',
  desc: 'Crol bilateral, espalda, pecho y ondulación inicial de mariposa.'
}, {
  n: 4,
  title: 'Niños Avanzado — Técnica y Entrenamiento',
  desc: 'Mariposa completa, voltereta, salida de bloque y series aeróbicas.'
}, {
  n: 5,
  title: 'Adultos Inicial (Parte 1) — Miedo al Agua y Flotación',
  desc: 'El primer paso para el adulto que nunca aprendió o que tiene miedo al agua.'
}, {
  n: 6,
  title: 'Adultos Inicial (Parte 2) — Respiración y Primer Largo',
  desc: 'Respiración lateral, primer largo autónomo y crol inicial.'
}, {
  n: 7,
  title: 'Adultos Intermedio 1 — Técnica y Eficiencia',
  desc: 'Crol bilateral, espalda coordinada y viraje abierto.'
}, {
  n: 8,
  title: 'Adultos Intermedio 2 — Resistencia y Series',
  desc: 'Zonas de FC, series aeróbicas y los 400 metros continuos.'
}, {
  n: 9,
  title: 'Adultos Avanzado — Entrenamiento de Alto Rendimiento',
  desc: 'Umbral anaeróbico, voltereta, paletas y entrenamiento por zonas.'
}, {
  n: 10,
  title: 'Adultos Mayores — Natación Adaptada',
  desc: 'Movilidad articular, flotación segura y bienestar en el agua.'
}, {
  n: 11,
  title: 'Terapéutico — Lesiones y Natación Restaurativa',
  desc: 'Protocolos para hombro, rodilla, lumbar y rehabilitación acuática.'
}, {
  n: 12,
  title: 'Juegos de Cierre y Recreación para Niveles Mixtos',
  desc: '20 juegos acuáticos con objetivos técnicos ocultos. La clase que todos recuerdan.'
}];
export function TomosGrid() {
  return <section className="py-20 bg-gray-50" data-id="element-327">
      <div className="max-w-6xl mx-auto px-4" data-id="element-328">
        <div className="text-center mb-16" data-id="element-329">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4" data-id="element-330">
            Los 12 Tomos Completos
          </h2>
          <p className="text-xl text-gray-600" data-id="element-331">
            Ejercicios graficados · Por nivel y objetivo · Listo para usar
            mañana
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-332">
          {tomos.map(t => <div key={t.n} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200 hover:shadow-md transition-shadow relative overflow-hidden group" data-id="element-333">
              <div className="absolute top-0 left-0 w-1 h-full bg-brand-blue group-hover:bg-brand-gold transition-colors" data-id="element-334"></div>
              <div className="text-brand-blue font-bold text-sm mb-2 tracking-wider" data-id="element-335">
                TOMO {t.n}
              </div>
              <h3 className="font-heading font-bold text-lg text-gray-900 mb-3 leading-tight" data-id="element-336">
                {t.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-337">{t.desc}</p>
            </div>)}
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200 max-w-4xl mx-auto" data-id="element-338">
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-339">
            <div className="flex flex-col items-center gap-2" data-id="element-340">
              <div className="bg-blue-50 p-3 rounded-full" data-id="element-341">
                <Pencil className="w-6 h-6 text-brand-blue" data-id="element-342" />
              </div>
              <span className="text-sm font-medium text-gray-700" data-id="element-343">
                Ejercicios graficados
                <br data-id="element-344" />
                en cada tomo
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-345">
              <div className="bg-yellow-50 p-3 rounded-full" data-id="element-346">
                <Zap className="w-6 h-6 text-yellow-600" data-id="element-347" />
              </div>
              <span className="text-sm font-medium text-gray-700" data-id="element-348">
                Sistema "Imprimí
                <br data-id="element-349" />y Enseñás"
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-350">
              <div className="bg-green-50 p-3 rounded-full" data-id="element-351">
                <ClipboardList className="w-6 h-6 text-green-600" data-id="element-352" />
              </div>
              <span className="text-sm font-medium text-gray-700" data-id="element-353">
                Planillas listas
                <br data-id="element-354" />
                para usar
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-355">
              <div className="bg-purple-50 p-3 rounded-full" data-id="element-356">
                <MapPin className="w-6 h-6 text-purple-600" data-id="element-357" />
              </div>
              <span className="text-sm font-medium text-gray-700" data-id="element-358">
                Contenido 100%
                <br data-id="element-359" />
                adaptado a Argentina
              </span>
            </div>
          </div>
        </div>

        {/* Extra CTA requested by user */}
        <div className="mt-16 text-center" data-id="element-360">
          <a href="#pricing" className="inline-block bg-brand-gold hover:bg-yellow-500 text-gray-900 font-bold text-lg py-4 px-8 rounded-xl shadow-lg shadow-brand-gold/30 transition-all transform hover:-translate-y-1" data-id="element-361">
            🔥 Quiero acceso completo AHORA — Asegurá tu lugar antes de que suba
            el precio
          </a>
        </div>
      </div>
    </section>;
}